import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import { LinkButton } from '@atlaskit/button/new';
import SettingsIcon from '@atlaskit/icon/core/settings';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { COMPANY_HUB_SETTINGS } from '@confluence/named-routes';

const i18n = defineMessages({
	buttonText: {
		id: 'company-hub.hub-settings.entry-button',
		defaultMessage: 'Hub Settings',
		description: 'Text for Hub settings entry point button',
	},
});

const buttonStyles = xcss({
	background: token('elevation.surface'),
	borderRadius: 'border.radius.100',
	boxShadow: 'elevation.shadow.raised',
});

export const HubSettingsEntryButton = () => (
	<Box xcss={buttonStyles}>
		<LinkButton appearance="subtle" iconBefore={SettingsIcon} href={COMPANY_HUB_SETTINGS.toUrl()}>
			<FormattedMessage {...i18n.buttonText} />
		</LinkButton>
	</Box>
);
